import { GibTypesState } from './types';
import { RootState } from 'store/root-reducer';
import { createSelector } from '@reduxjs/toolkit';

const selectGibTypesReducer = (state: RootState): GibTypesState => state.gibTypes;

export const selectGibTypesIsEmpty = createSelector([selectGibTypesReducer], (gibTypes) => gibTypes.gibTypesIsEmpty);

export const selectGibTypesLoading = createSelector([selectGibTypesReducer], (gibTypes) => gibTypes.gibTypesLoading);

export const selectGibTypes = createSelector([selectGibTypesReducer], (gibTypes) => gibTypes.gibTypes);
